import type { TemplateEntryDef, TemplateEntryField } from '@vivport/backend/types';
import { groupFieldsInDefOrder } from './entry-groups';

export type EntryStep =
  | { kind: 'identity'; label: string }
  | { kind: 'group'; label: string; group: string | null; fields: TemplateEntryField[] }
  | { kind: 'review'; label: string };

// Presentation only, derived per render — never persisted, never sent. Order comes from
// groupFieldsInDefOrder, which is already the order the backend composes the block in.
export function entrySteps(def: TemplateEntryDef): EntryStep[] {
  const groups = groupFieldsInDefOrder(def).map(
    ({ group, fields }): EntryStep => ({
      kind: 'group',
      label: group ?? 'Details',
      group,
      fields,
    })
  );
  return [{ kind: 'identity', label: def.itemLabel }, ...groups, { kind: 'review', label: 'Review' }];
}
